var myMenu = document.querySelector(".b-header__menu");
var oppMenu = document.querySelector(".b-button--menu-icon");
var inp = document.querySelector('.b-header__wrap-middle');
var bodyNode = document.body || document.getElementsByTagName('body')[0];

function toggleClassMenu() {
	myMenu.classList.add("b-header__menu--animatable");	
	if(!myMenu.classList.contains("b-header__menu--visible")) {		
		myMenu.classList.add("b-header__menu--visible");
		bodyNode.classList.add('fixedPosition');	
	} else {
		myMenu.classList.remove('b-header__menu--visible');	
		bodyNode.classList.remove('fixedPosition');	
	}	
}

function OnTransitionEnd() {
	myMenu.classList.remove("b-header__menu--animatable");
}

oppMenu.addEventListener("click", toggleClassMenu, false);
myMenu.addEventListener("click", toggleClassMenu, false);
inp.addEventListener("click", toggleClassMenu, true);





// WEBPACK FOOTER //
// ./src/js/general/menu.js